import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { transactions } from "../../rbac-consts";
import { default as SuperAdminTransactionsContainer } from "./superAdmin/TransactionsContainer";

const TransactionsWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={transactions.SUPER_ADMIN}
      yes={() => (
        <SuperAdminTransactionsContainer />
      )}
    />
  );
};

export default TransactionsWrapper;